import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSmileBeam,
  faMeh,
  faAngry,
  faQuestionCircle,
} from '@fortawesome/pro-light-svg-icons';

const SentimentIcon = ({ sentiment, size }) => {
  let icon = faQuestionCircle;
  let color = 'text-muted';
  if (sentiment === 'POSITIVE') {
    icon = faSmileBeam;
    color = 'text-success';
  } else if (sentiment === 'NEUTRAL') {
    icon = faMeh;
    color = 'text-warning';
  } else if (sentiment === 'NEGATIVE') {
    icon = faAngry;
    color = 'text-danger';
  }

  return (
    <FontAwesomeIcon
      fixedWidth
      icon={icon}
      className={color}
      size={size || '2x'}
      title={sentiment || 'N/A'}
    />
  );
};

export default SentimentIcon;
